import { SISTEMAS_ACESSO } from "./faqLabels";

/**
 * A API guarda as flags de sistema como 0/1 e o BooleanToggle trabalha com
 * booleano, por isso a conversão nas duas pontas.
 */
function defaultFaq() {
  const item = {
    id: null,
    titulo: "",
    tipo: "artigo",
    palavras_chave: [],
    conteudo: null,
  };

  SISTEMAS_ACESSO.forEach(({ campo }) => {
    item[campo] = false;
  });

  return item;
}

function normalizeFaqDaApi(faq) {
  const item = { ...faq };

  SISTEMAS_ACESSO.forEach(({ campo }) => {
    item[campo] = !!+faq[campo];
  });

  item.palavras_chave = faq.palavras_chave || [];

  return item;
}

function normalizeFaqParaApi(item) {
  const faq = { ...item };

  SISTEMAS_ACESSO.forEach(({ campo }) => {
    faq[campo] = item[campo] ? 1 : 0;
  });

  return faq;
}

function sistemasSelecionados(item) {
  return SISTEMAS_ACESSO.filter(({ campo }) => !!item[campo]).map(
    ({ campo }) => campo
  );
}

export {
  defaultFaq,
  normalizeFaqDaApi,
  normalizeFaqParaApi,
  sistemasSelecionados,
};
